import { render } from "./TheLoadingAnimation.vue?vue&type=template&id=0f0e8ff8&scoped=true"
const script = {}

import "./TheLoadingAnimation.vue?vue&type=style&index=0&id=0f0e8ff8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0e8ff8"]])

export default __exports__